import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SafeHtml from 'epic-react-common/src/components/SafeHtml';
import SquareButton from '../squareButton/SquareButton';

const Callout = ({headline, description, align, active, buttonText, buttonOnClick, buttonLink, dark}) => {
    const alignItems = () => {
        switch(align) {
        case 'center':
            return 'center';
        case 'left':
            return 'flex-start';
        case 'right':
            return 'flex-end';
        default:
            return 'center';
        }
    };

    const renderButton = () => {
        const config = { dark };

        if (buttonOnClick) {
            return <SquareButton handleClick={buttonOnClick} config={config}>{buttonText}</SquareButton>
        } else if (buttonLink) {
            return <Link to={buttonLink}><SquareButton config={config}>{buttonText}</SquareButton></Link>
        } else {
            return <SquareButton config={config}>{buttonText}</SquareButton>
        }
    }

    return (
        <div className="callout" style={{alignItems: alignItems(), textAlign: align}}>
            <SafeHtml
                element="h1"
                className="main-header"
                dangerouslySetInnerHTML={{ __html: headline }} />
            <div
                className="horizontal-line"
                style={{
                    transformOrigin: align,
                    transform: `scaleX(${active ? '1' : '0'})`
                }}
            />
            {
                description &&
                <div className="main-paragraph" dangerouslySetInnerHTML={{ __html: description }} />
            }
            { buttonText && renderButton() }
        </div>
    )
};

Callout.propTypes = {
    headline: PropTypes.string,
    description: PropTypes.string,
    align: PropTypes.string,
    active: PropTypes.bool,
    buttonText: PropTypes.string,
    buttonOnClick: PropTypes.func,
    buttonLink: PropTypes.string,
    dark: PropTypes.bool
};

Callout.defaultProps = {
    headline: '',
    description: null,
    align: 'center',
    active: false,
    buttonText: null,
    buttonOnClick: null,
    buttonLink: null,
    dark: false
};

export default Callout;
